import classnames from 'classnames';

export { classnames };
